@if (!hasRoute('login')) {
  <div class="sidenav" [ngClass]="collapsed() ? 'sidenav-collapsed' : 'sidenav-expanded'">
    <ul class="sidenav-nav" role="list">
      <!-- Super User Menu Item -->
      @if (isSuperUserLoggedIn()) {
        <li class="sidenav-nav-item super-user-menu"
          [ngClass]="superMenuSelected() ? 'active' : ''"
          role="listitem">
          <button class="sidenav-nav-link" (click)="onSuperUserClick()" pTooltip="Super User Dashboard"
            tooltipPosition="right" [tooltipDisabled]="!collapsed()"
            aria-label="Super User Dashboard">
            <div class="icon-wrapper">
              <img src="../../../../assets/img/activitypro-logo-dark.png" alt="Super User Dashboard" class="nav-icon" />
            </div>
            @if (!collapsed()) {
              <span class="sidenav-link-text">Super User Dashboard</span>
            }
          </button>
        </li>
      }
      <!-- Regular Menu Items -->
      @for (menu of menus(); track menu; let i = $index) {
        <!-- Category Header -->
        @if (menu.category && (i === 0 || menus()[i - 1]?.category !== menu.category)) {
          <li class="sidenav-category" [class.collapsed-hidden]="collapsed()" role="presentation">
            <span class="category-label">{{ menu.category }}</span>
          </li>
        }
        <li class="sidenav-nav-item" [style.--index]="i" [ngClass]="{
            active: selectedMenuIndex() === i && menu.subMenu.length === 0,
            'parent-menu-selected': isParentMenuSelected(i)
          }"
          role="listitem">
          <div class="menu-item">
            <button class="sidenav-nav-link" (click)="toggleSubmenu(menu, i, $event)"
              [routerLink]="menu.subMenu.length === 0 ? menu.route : null" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }" pTooltip="{{ menu.name }}" tooltipPosition="right"
              [tooltipDisabled]="!collapsed()" [attr.aria-label]="menu.name">
              <div class="icon-wrapper">
                <img [src]="menu.icon" [alt]="menu.name" class="nav-icon" />
              </div>
              @if (!collapsed()) {
                <span class="sidenav-link-text">{{ menu.name }}</span>
              }
              @if (menu.subMenu.length > 0 && !collapsed()) {
                <i class="fa-solid fa-chevron-right submenu-arrow" aria-hidden="true"></i>
              }
            </button>
          </div>
        </li>
      }
    </ul>

    <!-- User Profile + Logout (bottom of sidebar) -->
    <div class="sidebar-footer" [class.collapsed]="collapsed()">
      <div class="user-profile">
        <div class="user-avatar">{{ userName() ? userName()[0].toUpperCase() : '?' }}</div>
        @if (!collapsed()) {
          <div class="user-info">
            <span class="user-name">{{ userName() }}</span>
            <span class="user-email">{{ maskedEmail() }}</span>
          </div>
        }
        <button class="logout-btn-sidebar" (click)="logout()"
          pTooltip="Log out" tooltipPosition="right" [tooltipDisabled]="!collapsed()"
          title="Log out" aria-label="Log out">
          <i class="pi pi-sign-out"></i>
        </button>
      </div>
    </div>
  </div>
}

<!-- OverlayPanel for submenu -->
<p-popover #submenuPanel [dismissable]="true">
  <div class="submenu-content" role="list">
    @for (subMenu of currentSubmenuItems(); track subMenu; let j = $index) {
      <button class="submenu-item" role="listitem"
        (click)="subMenuRoute(subMenu, j); submenuPanel.hide()"
        [ngClass]="selectedSubMenuIndex() === j ? 'active' : ''">
        <img [src]="subMenu.icon" [alt]="subMenu.name" class="submenu-icon" />
        <span class="submenu-text">{{ subMenu.name }}</span>
      </button>
    }
  </div>
</p-popover>

<app-confirm-dialog
  [visible]="showLogoutConfirm()"
  title="Log out"
  message="Are you sure you want to log out?"
  icon="pi pi-sign-out"
  iconColor="var(--success-color)"
  confirmLabel="Log out"
  confirmIcon="pi pi-sign-out"
  confirmColor="primary"
  (confirmed)="performLogout()"
  (cancelled)="showLogoutConfirm.set(false)" />

